module.exports = __webpack_public_path__ + "static/media/service-box6-icon06.668177cf.png";